import { TODAY_START_TS_IN_SEC } from '../lib/enums';
import { DB, Stores } from '../db/dbschema';

export function getLatestEventsWTS(vid, cb) {
  GetValueByKey(Stores.LatestEventsWts, vid, cb);
}

export function getOldEventWTS(vid, cb) {
  GetValueByKey(Stores.OldEventsWts, vid, cb);
}

export function GetTodaysTlFromDb(vids) {
  let params = { vids: vids, fromTs: TODAY_START_TS_IN_SEC, toTs: Math.round(Date.now() / 1000) };
  return new Promise((resolve, reject) => {
    getNotifFromDb(params, (err, data) => {
      if (err) reject(err);
      else resolve(data);
    });
  });
}

function GetValueByKey(store, key, cb) {
  global.indexedDbClient.getValueByKey(DB.GL, store, key)
    .then((resp) => { cb(null, (resp || 0)); })
    .catch((e) => { cb(e); })
}

export async function getNotifFromDb(params, cb) {
  let res = [];
  if (params.vids && params.vids.length) {
    for (var i = 0; i < params.vids.length; i++) {
      let lowerBound, upperBound, limit;
      lowerBound = [params.vids[i], params.fromTs || 0];
      upperBound = [params.vids[i], (params.toTs || Math.round(Date.now() / 1000))];
      limit = params.count ? params.count : null;
      await global.indexedDbClient.getDataByRange(DB.GL, params.vids[i] + Stores._TimelineEvents, 'vid_ts', lowerBound, upperBound, limit, params.sort)
        .then((resp) => {
          if (resp && resp.length) res.push.apply(res, resp);
        })
        .catch((e) => {
          cb(e);
        })
    }
    cb(null, res);
  } else cb("Vehicle ids are missing");
}